import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ManagementLiveTasks from './ManagementLiveTasks';
import { buildReturnToFromLocation, navigateWithReturn } from '../../../shared/navigation';

/**
 * Management Task tab on the project page. Tasks belong to a project, so the
 * project comes from the URL and the list's own project picker is hidden.
 *
 * Opening a task goes to the full detail page. The project page restores its tab
 * from location.state, so carry `secondaryTab` along with `returnTo` — otherwise
 * back lands on Overview.
 */
const ProjectManagementTasks = ({ projectId }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const openTask = (taskId) =>
        navigateWithReturn(navigate, `/builder/management/tasks/${taskId}`, {
            returnTo: buildReturnToFromLocation(location),
            state: { secondaryTab: 'Management Task' }
        });

    return (
        <ManagementLiveTasks
            embedded
            lockProject
            projectId={projectId}
            onSelectTask={openTask}
        />
    );
};

export default ProjectManagementTasks;
